<template>
<div v-if="!noHealth" class="organ" :style="{ backgroundImage: 'url('+ ossUrl + '/diseasaBg.png)'}">
    <TopTabBar :tab-list="tabs" @change="changeTab"/>
    <!-- 健康总评 -->
    <total-list v-if="activeIndex == 0" :list="specials" :marks="marks"></total-list>
    <organ-model
     v-if="activeIndex == 1"
     :organ-list="diseasalist"
     report-type="thyroid"
     :datas="datas"
    />
  </div>
</template>
<script>
import { ossUrl } from "@/config";
import Report from "../../models/Report"
import OrganModel from "@/components/OrganModel"
import TopTabBar from "@/components/TopTabBar"
import TotalList from "@/components/TotalList"
import { tabs } from  "@/utils/tabs"
export default {
  name: 'Index',
  components: { OrganModel, TopTabBar, TotalList },
  data() {
    return {
        ossUrl,
        tabs: tabs.thyroid,
        noHealth: true, //是否有检测数据
        activeIndex: 0, //当前显示 0 人体 ，1 脊椎
        diseasalist:[], //人体器官
        specials:[], //列表
        sex:2, //性别,
        marks:'', //当前报告分数，
        datas: {},
     }
  },
  computed:{
        id(){
            return this.$route.query.id || ''
        },
        user_no(){
            return this.$route.query.user_no || ''
        },
    },
    created() {
        this.getReport()
    },
  methods: {
    changeTab(val) {
      this.activeIndex = val;
    },
    /** 对象转数组 */
    objToArray(obj) {
      let arr = [];
      for (const key in obj) {
        arr.push({ title: key, ...obj[key] });
      }
      return arr;
    },
    compare(property) {
        return function(a, b) {
        const value1 = a[property]
        const value2 = b[property]
        return value1 - value2
        }
    },
    getReport() {
      let params = {
            user_no:this.user_no,
            test_report_id:this.id
        }
        Report.getReports({...params},(res,err)=>{
            this.loading = true
            if(!err){
                this.diseasalist = res.list.map(e => {
                    e.showCon = false;
                    e.btntxt = "查看";
                    return e
                }),
                this.specials = res.special.map(e=>{ 
                  e.desc = e.desc.replace(/\\r\\n/g, '<br>');
                  e.showCon = false;
                  e.btntxt = "查看建议";
                  return e
                })
                this.noHealth = false
                this.sex = res.sex
                this.marks = res.marks
                this.datas = res;
            } 
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.organ{
  min-height: calc(100% - 20px);
  padding-bottom: 20px;
}
.nodata{
  position: relative;
  width: 640px;
  margin: auto;
  text-align: left;
  padding: 60px 0;
  line-height: 50px;
}
.nodata p{
    margin-bottom: 20px;
    margin-top: 0;
}
</style>